<template>
    <a-row type="flex" :gutter="16" class="container">
        <a-col flex="160px" class="listContainer">     
            <!-- <a-menu class="towerList"
                :selectedKeys="[ $route.params.id || '' ]"
                mode="inline" :inlineIndent="12"
                @select="selectTower"
            > -->
             <a-menu class="towerList"
                mode="inline" :inlineIndent="12"
            >
                <!-- <a-menu-item v-for="tower of towers" :key="tower.name"
                    >{{ tower.title }}</a-menu-item> -->
                <RecycleScroller class="scroller"
                    :items="towers" :item-size="32"
                    key-field="name" ref="scroller"
                >
                    <li slot-scope="{ item }" :key="item.name"
                        :class="{ 
                            'ant-menu-item-selected': $route.params.id == item.name 
                        }"
                        class="ant-menu-item" @click="selectTower(item.name)"
                    >{{ item.title }}</li>
                </RecycleScroller>
            </a-menu>
        </a-col>
        <a-col flex="auto">
            <div class="infoTable" v-if="$route.params.id">
                <a-divider orientation="left">基本信息</a-divider>
                <a-descriptions size="small"
                    :column="{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }"
                >
                    <a-descriptions-item label="name">
                        <a :href="towerInfo.link" target="_blank"> {{ towerInfo.name }} </a>
                    </a-descriptions-item>
                    <a-descriptions-item label="层数">
                        {{ towerInfo.floors }}
                    </a-descriptions-item>
                    <a-descriptions-item label="发布时间">
                        {{ format(towerInfo.createtime) }}
                    </a-descriptions-item>
                    <a-descriptions-item label="更新时间">
                        {{ format(towerInfo.updatetime) }}
                    </a-descriptions-item>
                </a-descriptions>
                <a-divider orientation="left">修改信息</a-divider>
                <a-form-model :model="form" :rules="rules" ref="loginForm"
                    :labelCol="{ span: 5 }" :wrapperCol="{ span: 15 }"
                    class="smallForm"
                >
                    <a-form-model-item label="标题">
                        <a-input v-model="form.title"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="颜色">
                        <a-radio-group v-model="form.color">
                            <a-radio-button 
                                v-for="(color, index) of colors" :key="index"
                                :value="index.toString()" :style="{ background: color.value }"
                            >
                                {{ color.name }}
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="标签" :wrapperCol="{ span: 18 }">
                        <a-checkbox-group :options="tags" v-model="tagProxy" />
                    </a-form-model-item>
                    <a-form-model-item label="作者的话" :wrapperCol="{ span: 18 }">
                        <a-textarea placeholder="显示在底部的话" v-model="form.text" :rows="3" />
                    </a-form-model-item>
                    <a-row type="flex" justify="end" :gutter="16">
                        <a-col>
                            <a-button @click="resetForm" :disabled="!diff">重置</a-button>
                        </a-col>
                        <a-col>
                            <a-button type="primary" @click="submitForm" :disabled="!diff">修改</a-button>
                        </a-col>
                        <a-col :span="2"></a-col>
                    </a-row>
                </a-form-model>
                <a-divider orientation="left">危险操作</a-divider>
                <a-row type="flex">
                    <a-col :span="10">
                        隐藏塔: <a-switch :value="form.hide"></a-switch>
                    </a-col>
                    <a-col flex="auto">
                        <a-button type="danger" @click="withdraw">下架</a-button>
                    </a-col>
                </a-row>
            </div>
            <a-empty v-else :description="false" />
        </a-col>
    </a-row>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller';
import { clone, createFormData } from '../../../utils/utils.js'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import axios from "../../../plugins/axios.js"
import { TAGS, COLORS } from '../../../constant.js';

let towerListMemo = null;
const towerMemo = {};
const infos = {
    name: "",
    createtime: 0,
    updatetime: 0,
    tag: "",
};
export default {
    data: () => ({
        towers: [],
        towerInfo: {},
        form: infos,
        rules: infos,
        tags: TAGS,
        colors: COLORS,
        diff: false,
    }),
    computed: {
        tagProxy: {
            get() {
                return this.form.tag.split('|');
            },
            set(value) {
                this.form.tag = value.join('|');
            }
        }
    },
    async created() {
        if (!towerListMemo) {
            const { data } = await axios.get(`/backend/admin/tower/list.php`);
            towerListMemo = data;
        }
        this.towers = towerListMemo;
        if (this.$route.params.id) {
            this.loadTower(this.$route.params.id);
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.id) {
            this.loadTower(to.params.id)
                .then(() => next());
        } else {
            next();
        }
    },
    methods: {
        selectTower(key) {
            this.$router.push({ name: 'modifyTower', params: { id: key } });
        },
        async loadTower(id, force = false) {
            if (!towerMemo[id] || force) {
                const { data } = await axios.get(`/backend/admin/tower/info.php?name=${id}`);
                towerMemo[id] = data.info;
            }
            this.towerInfo = towerMemo[id];
            this.form = clone(towerMemo[id]);
            this.showIndex(this.towers.findIndex(e => e.name == id));
        },
        showIndex(index) {
            this.$nextTick(() => {
                const scroller = this.$refs.scroller;
                if (scroller.$_startIndex > index || scroller.$_endIndex < index + 10) {
                    scroller.scrollToItem(Math.max(index - 3));
                }
            })
        },
        resetForm() {
            this.form = clone(this.towerInfo);
        },
        async submitForm() {
            const modification = {};
            for (let key in this.form) {
                if (this.form[key] != this.towerInfo[key]) {
                    modification[key] = this.form[key];
                }
            }
            this.loading = true;
            const { data } = await axios.post("/backend/admin/tower/modify.php", createFormData({
                modification: JSON.stringify(modification), name: this.$route.params.id
            }));
            this.loading = false;
            if (data.code == 0) {
                this.$message.success("修改成功");
                const newData = clone(this.form);
                towerMemo[this.$route.params.id] = newData;
                this.towerInfo = newData;
                this.diff = false;
            } else {
                this.$message.error("修改失败");
            }
        },
        withdraw() {
            this.$confirm({
                title: '下架确认',
                content: `确定要下架 ${ this.towerInfo.title } 吗, 操作后将无法撤回`,
                okText: '确认',
                cancelText: '取消',
                async onOk() {

                }
            });
        },
        format(timestr) {
            return new Date(Number(timestr) * 1000).toLocaleString()
        }
    },
    watch: {
        form: {
            handler(data) {
                for (let key in data) {
                    if (data[key] != this.towerInfo[key]) {
                        this.diff = true;
                        return;
                    }
                }
                this.diff = false;
            },
            deep: true
        }
    },
    components: {
        RecycleScroller
    }
}
</script>

<style lang="less">
.smallForm .ant-form-item {
    margin-bottom: 8px;
}
.towerList {
    width: 160px;
    height: 100%;
    border-right: 1px;
    .scroller {
        height: 100%;
    }
    .ant-menu-item {
        height: 24px;
        line-height: 24px;
    }
}
</style>

<style lang="less" scoped>
.container {
    height: 100%;
    flex-wrap: nowrap;
}
.listContainer {
    height: 100%;
}
.infoTable {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>